import { getTableColumns } from 'helpers';

const IDEAgentcolumns = [
  ['agentDeviceName', 'string', 'Device Name', 'left', true],
  ['manufacturer', 'string', 'Manufacturer', 'left', true],
  ['indIdeHolder', 'string', 'IDE Holder', 'left', true],
  ['indIdeHolderName', 'string', 'IDE Holder Name', 'left', true],
  ['indIdeNumber', 'string', 'IDE #', 'left', true],
  ['esysStatus', 'string', 'Status', 'left', true],
  ['esysStatusDate', 'date', 'Status Date', 'left', true],
  ['modifiedUser', 'string', 'Last Modified By', 'left', true],
  ['modifiedDate', 'date', 'Last Modified Date', 'left', true]
];


export default getTableColumns(IDEAgentcolumns);
